module.exports = __webpack_public_path__ + "static/img/git_box_act.0c070eb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/git_box_act.png
// module id = KeFs
// module chunks = 1